import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";
import { C5EventsEdit } from "./edit";
import { C5EventsNew } from "./new";
import { C5EventsTable } from "./table";

export default function C5Events() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Events");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<C5EventsEdit />} />
      <Route index element={<C5EventsTable />} />
      <Route path="/new" element={<C5EventsNew />} />
    </Routes>
  );
}
